import React, { useEffect, useState } from "react";
import { getPost } from "./api/forumApi";
import { useParams } from "react-router-dom";
import "./viewpost.css";

export default function ViewPost() {

  const { id } = useParams();

  const [post, setPost] = useState(null);
  const [liked, setLiked] = useState(false);


  useEffect(() => {
    getPost(id).then(res => setPost(res.data));
  }, [id]);


  if (!post)
    return (
      <div className="post-loading">
        <div className="loader"></div>
        Loading post...
      </div>
    );


return (

<div className="viewpost-page">


  <div className="viewpost-container">


    {post.image && (

      <div className="viewpost-image-box">

        <img
          className="viewpost-image"
          src={post.image}
          alt={post.title}
        />

        <div className="image-tag">
          Vortex Network
        </div>

      </div>

    )}



    <div className="viewpost-header">


      <h1 className="viewpost-title">
        {post.title}
      </h1>



      <div className="forum-meta">


        <div className="forum-user">


          <div className="user-avatar">
            {post.author?.charAt(0)}
          </div>


          <div>

            <span className="forum-author">

              <i className="fa-solid fa-user"></i>
              {" "}
              {post.author}

            </span>


            <span className="forum-date">

              <i className="fa-solid fa-clock"></i>
              {" "}
              {new Date(
                post.created_at
              ).toLocaleString()}

            </span>


          </div>


        </div>


      </div>


    </div>





    <div className="viewpost-content">

      {post.content}

    </div>





    <div className="placeholder">

      📌 test code here placeholder

    </div>





    <div className="post-actions">


      <button
        className={liked ? "active" : ""}
        onClick={() => setLiked(!liked)}
      >

        ❤️ {liked ? "Liked" : "Like"}

      </button>



      <button>

        💬 Reply

      </button>



      <button>

        🔗 Share

      </button>


    </div>



  </div>


</div>

);

}